import { render, staticRenderFns } from "./WinnerRequirementsModal.vue?vue&type=template&id=047c8ffc&scoped=true"
import script from "./WinnerRequirementsModal.vue?vue&type=script&lang=js"
export * from "./WinnerRequirementsModal.vue?vue&type=script&lang=js"
import style0 from "./WinnerRequirementsModal.vue?vue&type=style&index=0&id=047c8ffc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047c8ffc",
  null
  
)

export default component.exports